import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'coin-monero', 'CoinMonero', [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"}],["path",{"d":"M4 16h4v-7l4 4l4 -4v7h4"}]]);